export function pathToRoute(url?: string): {app?: string; to: string} {
  if (!url) {
    return {to: ""}
  }

  const [app, ...paths] = url.split("/")
  const to = paths.join("/")

  return {
    app,
    to
  }
}
